import React from 'react';
import loader from '../assets/images/loader2.svg';
import './loader.css'

const Loader = props => {
  
  return (
    <div  className="loader2">
    <img src={loader}  alt="Loading..."  />
    </div>
  )
}
export default Loader